import React from 'react';
import classnames from 'classnames';
import { CheckmarkIcon, Label, Input } from './Checkbox.styles';

type OwnProps = {
  dataQa?: string;
  disabled?: boolean;
  onClick?: () => void;
  value: boolean;
};

export default function Checkbox({ value, onClick, disabled, dataQa }: OwnProps) {
  const classNames = classnames({
    'is-checked': value
  });

  const handleOnClick = () => {
    if (disabled) return;
    onClick?.();
  };

  return (
    <>
      <Label role="button" onClick={handleOnClick} className={classNames}>
        <CheckmarkIcon className={classNames} />
      </Label>
      <Input data-qa={dataQa} type="checkbox" checked={value} value={value} readOnly />
    </>
  );
}
